import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import { addToCart, toggleWishlist } from "../../../../../actions";

import {
  quantityInputs,
  isIEBrowser,
  isEdgeBrowser,
  findIndex,
} from "../../../../../utils";
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";

function ProductDetailOne(props) {
  const { product, isWishlist, addToCart, toggleWishlist } = props;
  const [selectedVariant, setSelectedVariant] = useState(
    product.variants ? product.variants[0] : null
  );
  const [selectedSize, setSelectedSize] = useState(
    selectedVariant && selectedVariant.size ? selectedVariant.size[0] : null
  );
  const [selectedVariantIndex, setSelectedVariantIndex] = useState(0);
  const [quantity, setQuantity] = useState(1);
  const [price, setPrice] = useState(product.price);
  useEffect(() => {
    quantityInputs();
  }, []);

  useEffect(() => {
    setSelectedVariant(product.variants ? product.variants[0] : null);
    setSelectedSize(
      product.variants && product.variants[0] && product.variants[0].size
        ? product.variants[0].size[0]
        : null
    );
    setSelectedVariantIndex(0);
  }, [product.variants]);

  const addToCartHandler = () => {
    const selectedProduct = { ...product };
    const quantity = parseInt(document.querySelector("#qty").value);
    selectedProduct.price = price;
    if (!product.variants) {
      // No variants, add product to cart directly
      if (selectedProduct.stock > 0 && selectedProduct.stock >= quantity) {
        addToCart(selectedProduct, quantity);
      } else {
        return toast.error("Qty Not Avaiable");
      }
    } else {
      // Variants exist, handle variant selection
      if (
        selectedVariant &&
        selectedVariant.color &&
        selectedVariant.qty >= quantity
      ) {
        selectedProduct.selectedVariant = [
          {
            color: selectedVariant.color,
            color_name: selectedVariant.color_name,
            price: selectedVariant.price,
            qty: quantity,
          },
        ];

        // Check variant size quantity
        if (
          selectedVariant.size &&
          selectedSize &&
          selectedSize.qty > 0 &&
          selectedSize.qty >= quantity
        ) {
          selectedProduct.selectedVariant[0].size = [
            {
              qty: quantity,
              name: selectedSize.name,
            },
          ];
        }

        if (
          selectedProduct.stock > 0 &&
          selectedProduct.selectedVariant &&
          (!selectedProduct.selectedVariant[0].size ||
            selectedProduct.selectedVariant[0].size.length > 0)
        ) {
          addToCart(selectedProduct, quantity);
          setSelectedVariant(product.variants ? product.variants[0] : null);
        } else {
          toast.error("Qty Not Avaiable");
        }
      }
    }
  };

  const wishlistHandler = () => {
    if (isWishlist) {
      window.location = "/shop/wishlist";
    } else {
      toggleWishlist(product, isWishlist);
    }
  };

  const handleVariantClick = (variant, index) => {
    setSelectedVariant(variant);
    setSelectedVariantIndex(index);
    setPrice(variant.price);
    if (variant.size && variant.size.length > 0) {
      setSelectedSize(variant.size[0]);
    } else {
      setSelectedSize(null);
    }
  };

  const renderColorOptions = () => {
    return (
      <div className="product-nav product-nav-dots">
        {product.variants.map((variant, index) => (
          <>
            {/* <Link
              to="#"
              key={index}
              className={selectedVariantIndex === index ? "active" : ""}
              style={{ backgroundColor: variant.color }}
              onClick={() => handleVariantClick(variant, index)}
            ></Link> */}
            <button
              key={index}
              className={selectedVariantIndex === index ? "active" : ""}
              style={{ backgroundColor: variant.color }}
              onClickCapture={() => handleVariantClick(variant, index)}
            ></button>
          </>
        ))}
      </div>
    );
  };

  const renderSizeOptions = () => {
    const selectedVariantSizes = selectedVariant?.size || [];

    return (
      <>
        {product.variants && product.variants[0].size ? (
          <div className="details-filter-row details-row-size mb-md-1">
            <label>Size:</label>

            <div className="product-size">
              {selectedVariantSizes.map((size, index) => (
                <Link
                  to="#"
                  key={index}
                  title={size.name}
                  className={
                    size.qty > 0
                      ? selectedSize && size.name === selectedSize.name
                        ? "active"
                        : ""
                      : "disabled"
                  }
                  onClick={() => {
                    setSelectedSize(size);
                    setPrice(size.price);
                  }}
                >
                  {size.name}
                </Link>
              ))}
            </div>
            <Link to="#" className="size-guide">
              <i className="icon-th-list"></i>size guide
            </Link>
          </div>
        ) : (
          <></>
        )}
      </>
    );
  };

  return (
    <div className={"product-details"}>
      <Helmet>
        <title>LIBER | {product.name}</title>
      </Helmet>

      <h1 className="product-title">{product.name}</h1>

      <div className="ratings-container">
        <div className="ratings">
          <div
            className="ratings-val"
            style={{ width: product.ratings * 20 + "%" }}
          ></div>
        </div>
        <Link
          className="ratings-text"
          to="#product-review-link"
          id="review-link"
        >
          ( {product.reviews} Reviews )
        </Link>
      </div>

      {0 === product.stock ? (
        <div className="product-price">
          <span className="out-price">
            $
            {price.toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </span>
        </div>
      ) : 0 < product.discount ? (
        <div className="product-price">
          <span className="new-price">
            $
            {product.salePrice.toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </span>
          <span className="old-price">
            $
            {price.toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </span>
        </div>
      ) : (
        <div className="product-price">
          $
          {price.toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </div>
      )}

      <div className="product-content">
        <p>{product.shortDesc}</p>
      </div>

      {product.variants ? (
        <div className="details-filter-row details-row-size">
          <label>Color:</label>
          {product.variants[0].color ? (
            renderColorOptions()
          ) : (
            <div className="product-nav product-nav-thumbs">
              {product.variants.map((variant, index) => (
                <Link
                  to="#"
                  key={index}
                  className={selectedVariantIndex === index ? "active" : ""}
                  onClick={() => handleVariantClick(variant, index)}
                >
                  {variant.model ? (
                    <img src={variant.model} alt="product desc" />
                  ) : variant.image ? (
                    <img src={variant.image} alt="product desc" />
                  ) : null}
                </Link>
              ))}
            </div>
          )}
        </div>
      ) : (
        ""
      )}

      {renderSizeOptions()}

      <div className="details-filter-row details-row-size">
        <label htmlFor="qty">Qty:</label>
        <div className="product-details-quantity">
          <input
            type="number"
            id="qty"
            className="form-control"
            defaultValue="1"
            min="1"
            value={quantity}
            max={product.stock}
            step="1"
            data-decimals="0"
            onInput={(e) => setQuantity(e.target.value)}
            placeholder={quantity}
            contentEditable={false}
            // onClick={(e) => setQuantity(e.target.value)}
            // onChange={(e) => setQuantity(e.target.value)}
            disabled
            required
          />
        </div>
      </div>

      <div className="product-details-action">
        {isIEBrowser() || isEdgeBrowser() ? (
          <button
            className="btn-product btn-cart"
            onClick={addToCartHandler}
            style={{ minHeight: "4rem" }}
          >
            <span>add to cart</span>
          </button>
        ) : (
          <button className="btn-product btn-cart" onClick={addToCartHandler}>
            <span>add to cart</span>
          </button>
        )}
        {isIEBrowser() || isEdgeBrowser() ? (
          <div className="details-action-wrapper IE-detail-action-wrapper">
            <button
              className={`btn-product btn-wishlist pl-0 pr-0 ${
                isWishlist ? "added-to-wishlist" : "remove-from-wishlist"
              }`}
              onClick={wishlistHandler}
              title={isWishlist ? "Go to wishlist" : "Add to wishlist"}
            >
              <span>{isWishlist ? "go to wishlist" : "add to wishlist"}</span>
            </button>
          </div>
        ) : (
          <div className="details-action-wrapper">
            <button
              className={`btn-product btn-wishlist pl-0 pr-0 ${
                isWishlist ? "added-to-wishlist" : "remove-from-wishlist"
              }`}
              onClick={wishlistHandler}
              title={isWishlist ? "Go to wishlist" : "Add to wishlist"}
            >
              <span>{isWishlist ? "Go to Wishlist" : "Add to Wishlist"}</span>
            </button>
          </div>
        )}
      </div>

      <div className="product-details-footer">
        <div className="product-cat">
          <span>Category: </span>
          {product.category.map((cat, index) => (
            <span key={index} className="mr-0">
              <Link to="#">{cat}</Link>
              {index < product.category.length - 1 ? ", " : ""}
            </span>
          ))}
        </div>

        <div className="social-icons social-icons-sm">
          <span className="social-label">Share:</span>
          <Link to="#" className="social-icon" title="Facebook" target="_blank">
            <i className="icon-facebook-f"></i>
          </Link>
          <Link to="#" className="social-icon" title="Twitter" target="_blank">
            <i className="icon-twitter"></i>
          </Link>
          <Link
            to="#"
            className="social-icon"
            title="Instagram"
            target="_blank"
          >
            <i className="icon-instagram"></i>
          </Link>
          <Link
            to="#"
            className="social-icon"
            title="Pinterest"
            target="_blank"
          >
            <i className="icon-pinterest"></i>
          </Link>
        </div>
      </div>

      {props.children}
    </div>
  );
}

function mapStateToProps(state, props) {
  return {
    product: state.data.products.filter(
      (product) => product.id === parseInt(props.id)
    )[0],
    isWishlist:
      findIndex(
        state.wishlist.list,
        (item) => item.id === parseInt(props.id)
      ) !== -1,
  };
}

export default connect(mapStateToProps, { addToCart, toggleWishlist })(
  ProductDetailOne
);
